/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Dd_List7_LabelInputs */

const es_nav_dd_list7_label = /** @type {(inputs: Nav_Dd_List7_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alquila lista séptima`)
};

const gl_nav_dd_list7_label = /** @type {(inputs: Nav_Dd_List7_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aluga lista sétima`)
};

const en_nav_dd_list7_label = /** @type {(inputs: Nav_Dd_List7_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rent out List 7`)
};

/**
* | output |
* | --- |
* | "Rent out List 7" |
*
* @param {Nav_Dd_List7_LabelInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_dd_list7_label = /** @type {((inputs?: Nav_Dd_List7_LabelInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Dd_List7_LabelInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_nav_dd_list7_label(inputs)
	if (locale === "en") return en_nav_dd_list7_label(inputs)
	return es_nav_dd_list7_label(inputs)
});